var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinIdentify(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9.52615C2 4.28308 6.28308 0 11.5262 0C15.5508 0 19.1692 2.54769 20.4985 6.35077C22.2338 11.2985 19.6123 16.7631 14.6646 18.4985C14.5538 18.5354 14.4431 18.6092 14.4062 18.72L11.5262 24L8.64615 18.72C8.57231 18.6092 8.49846 18.5354 8.38769 18.4985C4.54769 17.1692 2 13.5877 2 9.52615ZM11.5261 16.283C15.1967 16.283 18.1723 13.3074 18.1723 9.63686C18.1723 5.96629 15.1967 2.99071 11.5261 2.99071C7.85557 2.99071 4.87999 5.96629 4.87999 9.63686C4.87999 13.3074 7.85557 16.283 11.5261 16.283Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.606,
    cy: 9.5,
    r: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIdentify);
export default __webpack_public_path__ + "static/media/pin_identify.a1b74f75ec857b133658a128b20fb3a9.svg";
export { ForwardRef as ReactComponent };